import React, { useState, useEffect } from "react";
import { Box } from "@mui/material";
// import { useResponsiveFontSize } from "../functions";

const FlashingSentence = ({
  sentences,
  interval,
  mainTextColor = "black",
  subTextColor = "black",
  mainTextSize,
  subTextSize,
}) => {
  // State to track the current index
  const [currentIndex, setCurrentIndex] = useState(0);
  // const mainTextSize = useResponsiveFontSize();

  useEffect(() => {
    // Set an interval to change the sentence every 5 seconds
    const intervalId = setInterval(() => {
      setCurrentIndex((prevIndex) => (prevIndex + 1) % sentences.length);
    }, interval);

    // Clean up the interval on component unmount
    return () => clearInterval(intervalId);
  }, [sentences.length, interval]);

  return (
    <Box
      sx={{
        textAlign: "center",
        color: mainTextColor,
        backgroundColor: "inherit",
      }}
    >
      <h1
        style={{
          fontSize: mainTextSize,
          fontWeight: "100",
          backgroundColor: "inherit",
        }}
      >
        {sentences[currentIndex]}
      </h1>
      {currentIndex !== 0 && (
        <p
          style={{
            fontSize: subTextSize,
            fontWeight: "500",
            color: subTextColor,
            backgroundColor: "inherit",
          }}
        >
          {sentences[0]}
        </p>
      )}
    </Box>
  );
};

export default FlashingSentence;
